<template>
    <div>
        <b-row>
            <b-col>
                <b-form-datepicker v-model="date" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col>
                <b-form-timepicker v-model="time" locale="en" hour12></b-form-timepicker>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "Entry",
    props: [ 'entry' ],
    data() {
        return {
            date: null,
            time: null,
        }
    },
    mounted() {
        this.date = null;
        this.time = null;
        this.date = moment(this.entry.timestamp).format('YYYY-MM-DD');
        this.time = moment(this.entry.timestamp).format('HH:mm:ss');
    },
    computed: {
        utcDate() {
            return moment(`${this.date} ${this.time}`).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    watch: {
        entry(entry) {
            console.log('entry', entry);
        },
        time() {
            this.$emit('dateChange', this.utcDate);
        },
        date() {
            this.$emit('dateChange', this.utcDate);
        }
    }
}
</script>

<style>
.modal-body {
    min-height: 350px;
}
</style>